export enum EntityType {
    Donor = 0,
    Gift = 1,
    RecurringGift = 2,
    Premium = 3,
    Project = 4,
    Form = 5
}
